import BusinessResult from './BusinessResult';

export default BusinessResult;